var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{directives:[{name:"dragscroll",rawName:"v-dragscroll.x",modifiers:{"x":true}}],staticClass:"py-0 section__title sv-breadcrumbs",attrs:{"items":_vm.items,"divider":_vm.divider,"dark":_vm.dark}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }